import {
  DOT_COM_PRODUCTION_MESSAGING_SUBDOMAIN,
  MESSAGING_SERVICE_SSE_PATH,
  PRODUCTION_MESSAGING_SUBDOMAIN,
  WEB_PROXY_SSE_PATH,
} from '../constants/url'

const isProductionHost = (hostname: string) =>
  !(hostname.includes('sandbox') || hostname.startsWith('localhost'))

export const getMessagingSSEURL = (urlString = document.URL) => {
  const { hostname, origin } = new URL(urlString)
  if (!isProductionHost(hostname)) return new URL(WEB_PROXY_SSE_PATH, origin)

  const topLevelDomain = hostname.slice(hostname.lastIndexOf('.') + 1)

  const subdomain =
    topLevelDomain === 'com'
      ? DOT_COM_PRODUCTION_MESSAGING_SUBDOMAIN
      : PRODUCTION_MESSAGING_SUBDOMAIN

  return new URL(MESSAGING_SERVICE_SSE_PATH, `https://${subdomain}.${topLevelDomain}`)
}
